import React from "react";
import { ourService } from "../Data";

const OurService = () => (
  <section className="py-10 md:py-16 px-5 lg:px-12 max-w-7xl mx-auto">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-8">
      {ourService.map((post, index) => (
        <div
          key={index}
          className="group p-6 md:p-8 rounded-2xl md:rounded-3xl bg-white border border-slate-100 shadow-[0_10px_40px_rgba(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)] hover:-translate-y-1 md:hover:-translate-y-2 transition-all duration-500 flex flex-col items-center text-center"
          data-aos="fade-up"
          data-aos-delay={index * 80}
        >
          {/* icon */}
          <div className="w-14 h-14 md:w-20 md:h-20 mb-5 md:mb-8 rounded-xl md:rounded-2xl bg-blue-50 flex items-center justify-center group-hover:bg-blue-600 transition-colors duration-500 flex-shrink-0">
            <img
              src={post.image}
              className="w-7 h-7 md:w-10 md:h-10 object-contain group-hover:invert transition-all duration-500"
              alt={post.title}
            />
          </div>

          <h3 className="text-xl md:text-2xl font-teko uppercase text-slate-900 mb-3 md:mb-4 tracking-wide group-hover:text-blue-600 transition-colors leading-tight">
            {post.title}
          </h3>

          <p className="text-slate-600 text-sm leading-relaxed mb-5 md:mb-6">
            {post.description}
          </p>

          <div className="mt-auto">
            <span className="w-10 h-1 bg-blue-200 group-hover:w-20 group-hover:bg-blue-600 transition-all duration-500 block mx-auto rounded-full" />
          </div>
        </div>
      ))}
    </div>
  </section>
);

const Service = () => {
  return (
    <div className="bg-slate-50 min-h-screen">
      <div data-theme="dark" className="h-48 md:h-64 relative flex items-center justify-center text-white overflow-hidden bg-gradient-to-b from-[#060b13] via-[#0b172a] to-[#050a12] rounded-b-[2.5rem] border-b border-blue-900/30 pt-[82px]">
        <div
          className="absolute inset-0 opacity-15"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.06) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.06) 1px,transparent 1px)",
            backgroundSize: "28px 28px",
          }}
        />
        {/* gradient blobs */}
        <div className="absolute top-0 right-0 w-72 h-72 rounded-full bg-blue-600/25 blur-[80px] pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-indigo-600/15 blur-[80px] pointer-events-none" />

        <div className="relative z-10 text-center px-4" data-aos="zoom-out">
          <h1 className="text-3xl md:text-5xl font-teko uppercase tracking-wider">
            Services
          </h1>
        </div>
      </div>

      <div className="max-w-3xl mx-auto text-center px-5 pt-10 md:pt-16 pb-4" data-aos="fade-up">
        <div className="mb-3">
          <span className="text-blue-600 font-bold tracking-widest uppercase text-[10px] border-b-2 border-blue-400 pb-1">
            What We Offer
          </span>
        </div>
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-teko uppercase text-slate-900 tracking-wide mb-4">
          Reliable Technology Services
        </h2>
        <p className="text-slate-600 text-sm md:text-lg leading-relaxed">
          We provide high-quality IT services tailored to your business needs,
          ensuring reliability and efficiency at every step.
        </p>
      </div>

      <OurService />
    </div>
  );
};

export default Service;
